import { ORDER_REDIRECT_URL } from '@/constants/order'

export const useOrderResult = () => {
  const router = useRouter()

  // 히스토리 남기지 않고 뒤로가기
  const replacePrevUrl = (partnerKey?: string) => {
    const prevUrl = sessionStorage.getItem(ORDER_REDIRECT_URL)

    sessionStorage.removeItem(ORDER_REDIRECT_URL)
    if (prevUrl) {
      router.replace(prevUrl)
    } else {
      router.replace(`${partnerKey ? `/partners/${partnerKey}` : '/'}`)
    }
  }

  // 결제 성공 시 세션 스토리지 정리하고 성공 페이지로 이동
  const redirectToSuccessPage = (
    isGuest: boolean,
    simUsageType: SimUsageType | '',
    simType: SimType | '',
    partnerKey: string,
    orderGroupId?: string
  ) => {
    sessionStorage.removeItem(ORDER_REDIRECT_URL)
    usePayment().goToOrderSuccessPage(isGuest, simUsageType, simType, partnerKey, orderGroupId)
  }

  return {
    replacePrevUrl,
    redirectToSuccessPage
  }
}
